"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Order = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _clsx3 = _interopRequireDefault(require("clsx"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _Image = require("../Image");
var _image_failure = _interopRequireDefault(require("../../assets/images/image_failure.svg"));
var _uiOptimisationOrderDefaultImg = _interopRequireDefault(require("../../assets/images/ui-optimisation-order-default-img.svg"));
var _context = require("../ConfigProvider/context");
var _Loader = require("../Loader");
var _OrderList = require("../OrderList");
var _LocaleProvider = require("../LocaleProvider");
var _constants = require("../../utils/constants");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var Order = function Order(props) {
  // 注释的代码新版本放开注释
  var action = props.action,
    className = props.className,
    title = props.title,
    price = props.price,
    image = props.image,
    specification = props.specification,
    handleClick = props.handleClick,
    _props$itemCount = props.itemCount,
    itemCount = _props$itemCount === void 0 ? 1 : _props$itemCount,
    itemsText = props.itemsText,
    itemText = props.itemText,
    orderStatusText = props.orderStatusText,
    handleStatusClick = props.handleStatusClick,
    _props$loading = props.loading,
    loading = _props$loading === void 0 ? false : _props$loading,
    _props$error = props.error,
    error = _props$error === void 0 ? false : _props$error,
    _props$orderCardType = props.orderCardType,
    orderCardType = _props$orderCardType === void 0 ? _OrderList.OrderCardType.oldCarousel : _props$orderCardType,
    totalPrice = props.totalPrice,
    totalText = props.totalText,
    _props$selectOrderTex = props.selectOrderText,
    selectOrderText = _props$selectOrderTex === void 0 ? '' : _props$selectOrderTex,
    allowSelectBtn = props.allowSelectBtn,
    _props$showTotalText = props.showTotalText,
    showTotalText = _props$showTotalText === void 0 ? true : _props$showTotalText,
    _props$showOneLineTit = props.showOneLineTitle,
    showOneLineTitle = _props$showOneLineTit === void 0 ? false : _props$showOneLineTit,
    createdTime = props.createdTime,
    deliverer = props.deliverer,
    copyText = props.copyText,
    orderSn = props.orderSn,
    showPredictedText = props.showPredictedText,
    predictedText = props.predictedText,
    isUIOptimisationHotQuestion = props.isUIOptimisationHotQuestion,
    _props$milestone = props.milestone,
    milestone = _props$milestone === void 0 ? {} : _props$milestone;
  var context = (0, _react.useContext)(_context.ConfigContext);
  var _useLocale = (0, _LocaleProvider.useLocale)(),
    trans = _useLocale.trans;
  var priceTextRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    priceIsMultiline = _useState2[0],
    setPriceIsMultiline = _useState2[1];
  var orderInfoTextRef = (0, _react.useRef)(null);
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    orderInfoIsMultiline = _useState4[0],
    setOrderInfoIsMultiline = _useState4[1];
  var handleCardClick = function handleCardClick() {
    var _context$eventEmitter, _context$eventEmitter2;
    action && (context === null || context === void 0 ? void 0 : (_context$eventEmitter = context.eventEmitter) === null || _context$eventEmitter === void 0 ? void 0 : (_context$eventEmitter2 = _context$eventEmitter.emit) === null || _context$eventEmitter2 === void 0 ? void 0 : _context$eventEmitter2.call(_context$eventEmitter, action === null || action === void 0 ? void 0 : action.func, {
      action: action
    }));
    handleClick === null || handleClick === void 0 ? void 0 : handleClick();
  };
  var handleCopyClick = function handleCopyClick() {
    var _props$handleCopyClic;
    (_props$handleCopyClic = props.handleCopyClick) === null || _props$handleCopyClic === void 0 ? void 0 : _props$handleCopyClic.call(props);
  };
  (0, _react.useEffect)(function () {
    if (priceTextRef.current) {
      // 记录 ui 优化 price 是单行还是多行
      var lineHeight = parseFloat(getComputedStyle(priceTextRef.current).lineHeight) + 1;
      var textHeight = priceTextRef.current.clientHeight;
      if (textHeight > lineHeight) {
        setPriceIsMultiline(true);
      } else {
        setPriceIsMultiline(false);
      }
    }
    if (orderInfoTextRef.current) {
      // 记录 ui 优化 info status 是单行还是多行
      var _lineHeight = parseFloat(getComputedStyle(orderInfoTextRef.current).lineHeight);
      var _textHeight = orderInfoTextRef.current.clientHeight;
      if (_textHeight > _lineHeight) {
        setOrderInfoIsMultiline(true);
      } else {
        setOrderInfoIsMultiline(false);
      }
    }
  }, []);
  var renderOrderInfo = function renderOrderInfo() {
    if (isUIOptimisationHotQuestion) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _getPrefixCls.getPrefixCls)('order-info-detail')
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _getPrefixCls.getPrefixCls)('order-info-detail-price'),
        ref: priceTextRef
      }, itemCount, " ", itemCount > 1 ? itemsText || trans(_constants.ITEMS_TEXT) : itemText || trans(_constants.ITEM_TEXT), priceIsMultiline ? '' : ',', "\xA0", /*#__PURE__*/_react.default.createElement("span", {
        style: {
          display: priceIsMultiline ? 'block' : 'inline'
        }
      }, /*#__PURE__*/_react.default.createElement("span", null, totalText || trans(_constants.TOTAL_TEXT), ":"), " ", totalPrice))), /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _getPrefixCls.getPrefixCls)('order-info-milestone')
      }, milestone !== null && milestone !== void 0 && milestone.icon ? milestone === null || milestone === void 0 ? void 0 : milestone.icon : null, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _getPrefixCls.getPrefixCls)('order-info-milestone-text'),
        ref: orderInfoTextRef
      }, milestone !== null && milestone !== void 0 && milestone.text ? milestone === null || milestone === void 0 ? void 0 : milestone.text : orderStatusText)));
    }
    if (orderCardType === _OrderList.OrderCardType.oldCarousel) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _getPrefixCls.getPrefixCls)('order-info-specification')
      }, specification), /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _getPrefixCls.getPrefixCls)('order-info-price')
      }, price));
    }
    if (orderCardType === _OrderList.OrderCardType.orderWithCopy) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _getPrefixCls.getPrefixCls)('order-info-delivered-new')
      }, trans(_constants.DELIVERED_BY_TEXT), ": ", deliverer), /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _getPrefixCls.getPrefixCls)('order-info-tracing-box')
      }, orderSn, ' ', /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _getPrefixCls.getPrefixCls)('order-info-copy'),
        onClick: handleCopyClick
      }, copyText || trans(_constants.COPY_TEXT))));
    }
    if (orderCardType === _OrderList.OrderCardType.smallOrder) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _getPrefixCls.getPrefixCls)('order-info-detail')
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _getPrefixCls.getPrefixCls)('order-info-detail-status')
      }, orderStatusText), /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _getPrefixCls.getPrefixCls)('order-info-detail-price')
      }, /*#__PURE__*/_react.default.createElement("span", null, totalText || trans(_constants.TOTAL_TEXT), ":"), totalPrice)));
    }
    if (orderCardType === _OrderList.OrderCardType.foodCardInList) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _getPrefixCls.getPrefixCls)('order-info-specification')
      }, specification), /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _getPrefixCls.getPrefixCls)('order-info-detail')
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _getPrefixCls.getPrefixCls)('order-info-detail-price')
      }, orderCardType !== _OrderList.OrderCardType.bigCarousel && showTotalText && /*#__PURE__*/_react.default.createElement("span", null, totalText || trans(_constants.TOTAL_TEXT), ":"), totalPrice)));
    }
    if (orderCardType === _OrderList.OrderCardType.foodCard) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _getPrefixCls.getPrefixCls)('order-info-detail')
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _getPrefixCls.getPrefixCls)('order-info-detail-price')
      }, orderCardType !== _OrderList.OrderCardType.bigCarousel && showTotalText && /*#__PURE__*/_react.default.createElement("span", null, totalText || trans(_constants.TOTAL_TEXT), ":"), totalPrice)), /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _getPrefixCls.getPrefixCls)('order-info-wrap')
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _getPrefixCls.getPrefixCls)('order-info-wrap-time')
      }, createdTime)));
    }
    if (orderCardType === _OrderList.OrderCardType.expeditedDelivery) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _getPrefixCls.getPrefixCls)('order-info-detail')
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _getPrefixCls.getPrefixCls)('order-info-detail-deliver-status')
      }, orderStatusText), /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _getPrefixCls.getPrefixCls)('order-info-detail-deliver-text')
      }, deliverer)));
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _getPrefixCls.getPrefixCls)('order-info-detail')
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _getPrefixCls.getPrefixCls)('order-info-detail-item')
    }, ' ', itemCount, " ", itemCount > 1 ? itemsText || trans(_constants.ITEMS_TEXT) : itemText || trans(_constants.ITEM_TEXT)), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _getPrefixCls.getPrefixCls)('order-info-detail-price')
    }, orderCardType !== _OrderList.OrderCardType.bigCarousel && showTotalText && /*#__PURE__*/_react.default.createElement("span", null, totalText || trans(_constants.TOTAL_TEXT), ":"), ' ', totalPrice)), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _getPrefixCls.getPrefixCls)('order-info-wrap')
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _getPrefixCls.getPrefixCls)('order-info-wrap-status')
    }, orderStatusText), (orderCardType === _OrderList.OrderCardType.verticalList || orderCardType === _OrderList.OrderCardType.twoRowCarousel) && allowSelectBtn && /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _getPrefixCls.getPrefixCls)('order-info-wrap-select-btn')
    }, selectOrderText)), createdTime && /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _getPrefixCls.getPrefixCls)('order-info-time')
    }, createdTime));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx3.default)((0, _getPrefixCls.getPrefixCls)('order-container'), (0, _getPrefixCls.getPrefixCls)("order-container-".concat(_OrderList.orderCardStyleMap[orderCardType])), className, (0, _defineProperty2.default)({}, (0, _getPrefixCls.getPrefixCls)('order-container-ui-optimisation-hot-question'), isUIOptimisationHotQuestion)),
    onClick: function onClick() {
      return handleCardClick();
    }
  }, loading ? /*#__PURE__*/_react.default.createElement(_Loader.AgentUploadLoading, null) : /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _getPrefixCls.getPrefixCls)('order-status-icon'),
    onClick: function onClick() {
      return handleStatusClick === null || handleStatusClick === void 0 ? void 0 : handleStatusClick();
    }
  }, error && /*#__PURE__*/_react.default.createElement(_Image.Image, {
    src: _image_failure.default
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx3.default)((0, _getPrefixCls.getPrefixCls)('order-image'), (0, _defineProperty2.default)({}, (0, _getPrefixCls.getPrefixCls)('order-image-big'), isUIOptimisationHotQuestion && (priceIsMultiline || orderInfoIsMultiline)))
  }, /*#__PURE__*/_react.default.createElement(_Image.Image, {
    src: image,
    fallback: isUIOptimisationHotQuestion ? _uiOptimisationOrderDefaultImg.default : '',
    className: (0, _getPrefixCls.getPrefixCls)('order-image-container')
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _getPrefixCls.getPrefixCls)('order-info')
  }, showPredictedText && predictedText ? /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _getPrefixCls.getPrefixCls)('order-info-recommendation')
  }, predictedText) : null, /*#__PURE__*/_react.default.createElement("div", {
    className: orderCardType === _OrderList.OrderCardType.foodCardInList || showOneLineTitle || showPredictedText && predictedText ? (0, _getPrefixCls.getPrefixCls)('order-info-name_one-line') : (0, _getPrefixCls.getPrefixCls)('order-info-name')
  }, title), renderOrderInfo()));
};
exports.Order = Order;